export type ValidationStatus = "expired" | "canceled" | "used"

export interface ValidationInfo {
    message: string
    description: string
}

export const VALIDATION_MESSAGES: Record<ValidationStatus, ValidationInfo> = {
    used: {
        message: "qr.used.message",
        description:
            "qr.used.description",
    },

    expired: {
        message: "qr.expired.message",
        description:
            "qr.expired.description",
    },

    canceled: {
        message: "qr.canceled.message",
        description:
            "qr.canceled.description",
    },
}

export const DEFAULT_VALIDATION_MESSAGE: ValidationInfo = {
    message: "qr.default.message",
    description:
        "qr.default.description",
}

export const SUCCESS_VALIDATION_MESSAGE: ValidationInfo = {
    message: "qr.success.message",
    description:
        "qr.success.description",
}